import { render, staticRenderFns } from "./AzureEventHubEndpointView.vue?vue&type=template&id=f5bf356e&scoped=true&"
import script from "./AzureEventHubEndpointView.vue?vue&type=script&lang=ts&"
export * from "./AzureEventHubEndpointView.vue?vue&type=script&lang=ts&"
import style0 from "./AzureEventHubEndpointView.vue?vue&type=style&index=0&id=f5bf356e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5bf356e",
  null
  
)

export default component.exports